import React from "react";
import "./Promotions.css";
import qrcode from "assets/images/qrcode(1).png";
import iosButton from "assets/images/ios_button.png";
import googleButton from "assets/images/google_button.png";
import huaweiButton from "assets/images/huawei_button.png";

const DownloadSection = () => {
  return (
    <section
      className="text-center rize-download text-white call-to-action pt-5 pb-0"
      id="download"
      style={{ background: "#e6f5fb" }}
    >
      <div
        style={{
          paddingBottom: "0px",
          background: "#d7e7f8",
          borderColor: "#e6f5fb",
          fontFamily: "Poppins, sans-serif",
          marginTop: "-1px",
        }}
      ></div>
      <div className="container">
        <div className="row">
          <div
            className="col-xl-9 mx-auto position-relative aos-init"
            data-aos="fade-up"
            data-aos-delay="150"
          >
            <h1
              className="mb-4 fontresizeheaderdownload"
              style={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: 900,
                color: "#0067ee",
              }}
            >
              <div className="ccm-custom-style-container ccm-custom-style-downloadsectionheader-271">
                <p>Download Rize now</p>
              </div>
            </h1>
            <center>
              <p>
                <img
                  src={qrcode}
                  alt="QR Code"
                  width="231"
                  height="258"
                  className="d-md-block d-none"
                  style={{
                    width: "12em",
                    height: "auto",
                    marginBottom: "29px",
                    padding: "10px",
                  }}
                />
              </p>
            </center>
            <div className="row p-0 m-0">
              <div className="col" style={{ paddingBottom: "0px" }}>
                <div className="ccm-custom-style-container  ccm-custom-style-downloadsectionbuttons-353">
                  <p>
                    <a
                      href="https://apps.apple.com/app/rize-my/id1587293861"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={iosButton}
                        alt="Download on iOS"
                        width="200vw"
                        height="auto"
                        style={{ paddingRight: "10px", paddingLeft: "10px" }}
                      />
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=my.com.alrajhibank.wick"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={googleButton}
                        alt="Download on Google Play"
                        width="200vw"
                        height="auto"
                        style={{
                          paddingRight: "10px",
                          paddingLeft: "10px",
                          paddingTop: "10px",
                          paddingBottom: "10px",
                        }}
                      />
                    </a>
                    <a
                      href="https://appgallery.huawei.com/app/C104770227"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={huaweiButton}
                        alt="Download on Huawei"
                        width="200vw"
                        height="auto"
                        style={{ paddingRight: "10px", paddingLeft: "10px" }}
                      />
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadSection;
